import { render, staticRenderFns } from "./vuepdf.vue?vue&type=template&id=f09c84ea&scoped=true"
import script from "./vuepdf.vue?vue&type=script&lang=js"
export * from "./vuepdf.vue?vue&type=script&lang=js"
import style0 from "./vuepdf.vue?vue&type=style&index=0&id=f09c84ea&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09c84ea",
  null
  
)

export default component.exports